// import { Locale } from "@prisma/client";

export enum Languages {
  EN_US = "English (US)",
  FR_FR = "Français (France)",
}

export enum Languages_MIN {
  EN_US = "EN",
  FR_FR = "FR",
}

export const INVERTED_Languages_MIN = Object.fromEntries(
  Object.entries(Languages_MIN).map(([key, value]) => [value.toLowerCase(), key]),
);

export const LOCALES = ["fr", "en"];

export enum Locales {
  EN_US = "en",
  FR_FR = "fr",
}

export const DEFAULT_LOCALE = LOCALES[0];
export const DEFAULT_LANGUAGE: keyof typeof Languages = "FR_FR";

/*
export function getLangFromLocale(locale: string | undefined | Locale): string {
	let lang = LOCALES[0];

	switch (locale) {
		case Locale.EN:
			lang = Locales.EN_US;
			break;
		case Locale.FR:
			lang = Locales.FR_FR;
			break;
	}

	return lang;
}
 */

export function languagesObject(): { [key: string]: string } {
  const obj: { [key: string]: string } = {};

  Object.keys(Languages).forEach((key) => {
    // @ts-expect-error
    obj[key] = Languages[key];
  });

  return obj;
}

export function getLanguageParam(lang: string): string {
  let _lang: keyof typeof Languages = INVERTED_Languages_MIN[
    lang?.toLowerCase()
  ] as keyof typeof Languages;

  if (!_lang) {
    _lang = DEFAULT_LANGUAGE;
  }

  return `?language=${_lang}`;
}

export function getLanguageName(code: string | null | undefined): string | null {
  if (!code) {
    return null;
  }

  const upper = code.toUpperCase();
  if (upper in Languages) {
    return Languages[upper as keyof typeof Languages];
  }

  const mapped = INVERTED_Languages_MIN[code.toLowerCase()];
  if (mapped && mapped in Languages) {
    return Languages[mapped as keyof typeof Languages];
  }

  return null;
}

export function buildLanguageInstruction(code: string | null | undefined): string {
  const languageName = getLanguageName(code);

  if (languageName) {
    return `ALL output text MUST be written exclusively in ${languageName}. This is mandatory and overrides the language of these instructions. Never output any other language, even if some input fragments are in a different language.`;
  }

  return "ALL output text MUST be written exclusively in the dominant language of the input data provided below. This overrides the language of these instructions. Never mix languages.";
}

export function getExportLocale(lang: string | undefined): string | null {
  if (lang?.toUpperCase().startsWith(Languages_MIN.FR_FR)) {
    return Locales.FR_FR;
  } else if (lang?.toUpperCase().startsWith(Languages_MIN.EN_US)) {
    return Locales.EN_US;
  }
  return null;
}
